import Celestial from "./celestial";

export default class BlackHole extends Celestial{}